// Adres zaplecza i żeton sesji (docs/pwa/NATYWNA.md 3) - jedno miejsce dla wszystkich dróg do zaplecza (zaplecze.ts,
// i18n/t.ts, brama/polaczenie.ts, brama/ekran.ts). Przeglądarka: APP pod adresem zaplecza (Worker APP przekazuje /api/
// i /brama/), sesja w ciasteczku HttpOnly - adres względny, bez nagłówka. Aplikacja ze sklepu: paczka w telefonie, inny
// adres - stały adres zaplecza i żeton sesji z Keychain / Keystore w nagłówku Authorization (worker-go auth.Guard.Token);
// WebSocket nie ma nagłówków - żeton w podprotokole.
import { SecureStorage } from "@aparajita/capacitor-secure-storage";
import { natywna } from "../uklad/instalacja";
import { pushWAplikacji, wtyczkaPowiadomien } from "../uklad/wtyczkaPowiadomien";

/** Zaplecze aplikacji ze sklepu = adres nowej APP (po zrównaniu funkcji app.termometrwifi.pl - pwa/wrangler.toml). */
const ZAPLECZE_APLIKACJI = "https://nowa.termometrwifi.pl";
const KLUCZ_ZETONU = "sesja";
/** Podprotokół WebSocket z żetonem (worker-go auth.WSProtocol). */
const PROTOKOL_WS = "twf.sesja";

const baza = natywna() ? ZAPLECZE_APLIKACJI : "";
let zeton = "";

/** Sesja także dla kodu natywnego (przyciski w powiadomieniu, potwierdzenie doręczenia przy zamkniętej aplikacji). */
const doWtyczki = () => {
  if (pushWAplikacji()) void wtyczkaPowiadomien.sesja({ zeton, zaplecze: ZAPLECZE_APLIKACJI }).catch(() => undefined);
};

const wczytany: Promise<void> = natywna()
  ? SecureStorage.getItem(KLUCZ_ZETONU).then((v) => { zeton = v ?? ""; doWtyczki(); }).catch(() => undefined)
  : Promise.resolve();

/** Pełny adres ścieżki zaplecza (`/api/...`, `/brama/...`). */
export const adres = (sciezka: string) => baza + sciezka;

/** Nagłówki zapytania z żetonem sesji (aplikacja ze sklepu, po zalogowaniu). */
export async function naglowki(inne?: Record<string, string>): Promise<Record<string, string>> {
  await wczytany;
  return zeton ? { ...inne, Authorization: "Bearer " + zeton } : { ...inne };
}

/** Żeton z odpowiedzi logowania (`zeton`; przeglądarka go nie dostaje) albo "" - wylogowanie / koniec sesji. */
export async function ustawZeton(z: string | undefined): Promise<void> {
  if (!natywna() || z === undefined || z === zeton) return;
  zeton = z;
  doWtyczki();
  try {
    if (z) await SecureStorage.setItem(KLUCZ_ZETONU, z);
    else await SecureStorage.removeItem(KLUCZ_ZETONU);
  } catch { /* bez Keychain / Keystore - sesja do zamknięcia aplikacji */ }
}

/** WebSocket do zaplecza: adres (przeglądarka - host APP, aplikacja - zaplecze) i podprotokoły z żetonem. */
export async function gniazdo(sciezka: string): Promise<WebSocket> {
  await wczytany;
  const u = new URL(adres(sciezka), location.href);
  u.protocol = u.protocol === "https:" ? "wss:" : "ws:";
  return zeton ? new WebSocket(u.href, [PROTOKOL_WS, zeton]) : new WebSocket(u.href);
}
